import edit from "./edit.js";
import parse from "./parse.js";
import format from "./format.js";
import { isReadOnly, getOperation, getSelection, setCaretPosition, getCaretPosition } from "./dom.js";
function onChange(event, input, _parse, _format, on_change) {
  formatInputText(input, _parse, _format, void 0, on_change);
}
function onKeyDown(event, input, _parse, _format, on_change) {
  if (!isReadOnly(input)) {
    var operation = getOperation(event);
    switch (operation) {
      case "Delete":
      case "Backspace":
        event.preventDefault();
        var selection = getSelection(input);
        return selection ? (eraseSelection(input, selection), formatInputText(input, _parse, _format, void 0, on_change)) : formatInputText(input, _parse, _format, operation, on_change);
    }
  }
}
function eraseSelection(input, selection) {
  var text = input.value;
  text = text.slice(0, selection.start) + text.slice(selection.end), input.value = text, setCaretPosition(input, selection.start);
}
function formatInputText(input, _parse, _format, operation, on_change) {
  var _parse2 = parse(input.value, getCaretPosition(input), _parse), value = _parse2.value, caret = _parse2.caret;
  if (operation) {
    var newValueAndCaret = edit(value, caret, operation);
    value = newValueAndCaret.value, caret = newValueAndCaret.caret;
  }
  var formatted = format(value, caret, _format), text = formatted.text;
  caret = formatted.caret, input.value = text, setCaretPosition(input, caret), on_change && on_change(value);
}
export {
  onChange,
  onKeyDown
};
//# sourceMappingURL=inputControl.js.map
